import { useShoppingCart } from "~/utils/context/useShoppingCart"
import InputError from "./InputError";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function Input({ id, name, autoComplete, type, readOnly, label, defaultValue, onChange, fieldErrors, maxLength, onBlur, hasTab, required }: { id: string, name: string, autoComplete?: string, type: string, readOnly: boolean, label: string, defaultValue?: string, onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void, fieldErrors?: { [key: string]: string }, maxLength?: number, onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void, hasTab?: boolean, required?: boolean }) {
    const { fieldHasError, getFieldError } = useShoppingCart();
    return (
        <>
            <label htmlFor={id} className={`block text-sm font-medium text-gray-700`}>
                {label}
            </label>
            <div className="mt-1 relative">
                <input
                    id={id}
                    name={name}
                    type={type}
                    autoComplete={autoComplete ? autoComplete : 'off'}
                    className={`block w-full rounded-md border-gray-300 shadow-sm focus:outline-none  focus:border-gray-300 focus:ring-gray-200 sm:text-sm read-only:cursor-not-allowed read-only:bg-gray-100 read-only:text-gray-500 read-only:ring-gray-200 ${fieldHasError(name) ? 'text-red-900 ring-red-300 ring-1 ring-inset placeholder:text-red-300' : ''}`}
                    readOnly={readOnly}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onBlur={onBlur}
                    maxLength={maxLength}
                    {...(!hasTab && { tabIndex: -1 })}
                    {...(required && { required: true })}

                />
                {fieldHasError(name) || fieldErrors?.[name] ?
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <ExclamationCircleIcon aria-hidden="true" className="size-5 text-red-500" />
                    </div>
                    : null}
            </div>
            {fieldHasError(name) || fieldErrors?.[name] ?
                <InputError message={fieldHasError(name) ? getFieldError(name) : fieldErrors?.[name] ? fieldErrors?.[name] : ''} />
                : null}
        </>
    )
};
